var exports = {
  "g": "AccentColorPicker.module__errorMessage___SnRzZ2",
};

module.exports = exports;
